module.exports = __webpack_public_path__ + "static/media/onda-violeta-4.6d83eeb5.png";